module.exports = ".income-summary{position:relative}.income-summary .cover{position:absolute;left:0;right:0;bottom:0;top:0;background-color:#000;opacity:0.4;border:1px solid #1f1f1f}.income-summary .flex{position:relative}.income-summary .label{color:#9E9E9E;font-size:10px}.income-summary .net{font-size:32px}.income-summary .tax,.income-summary .margin,.income-summary .gross{font-size:20px}.income-summary .margin.negative{color:#E41736}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounting/profit-loss/profit/profit-summary/profit-summary.component.scss
// module id = 885
// module chunks = 0